import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="pt-40 pb-24 text-center" data-testid="page-not-found">
      <div className="container-secqre">
        <span className="overline">— 404</span>
        <h1 className="mt-4 font-heading font-black text-6xl md:text-8xl tracking-tight">Lost in the lot.</h1>
        <p className="mt-6 text-lg text-[#475569] max-w-md mx-auto">This page wandered off without leaving a SECQRE tag. Let&apos;s get you back to the road.</p>
        <Link to="/" className="btn-primary mt-8">Take me home</Link>
      </div>
    </section>
  );
}
